module.exports = __webpack_public_path__ + "assets/files/test_dimensions_import.csv";